/* eslint-disable react/jsx-no-bind */
import { Box, FormControl, FormLabel, Select, VStack } from "@chakra-ui/react";
import { FC, useMemo, useState } from "react";

import { SectionCard } from "~/src/components/common/SectionCard";
import { chakraFactory } from "~/src/lib/chakra-ui";
import { userTagModuleStatusLabel } from "~/src/utils/userTagModuleFormatters";

import { VersionComparePanel } from "./VersionComparePanel";
import type { VersionItem } from "./VersionList";

const StyledSectionCard = chakraFactory(SectionCard, {
  baseStyle: {
    maxWidth: "800px",
    margin: "24px auto 0 auto",
  },
});

type ModuleItem = {
  id: string;
  name: string;
  versions: readonly VersionItem[];
};

type Props = {
  modules: readonly ModuleItem[];
  onShowDiff: (base: VersionItem, compare: VersionItem) => void;
};

export const VersionCompareTab: FC<Props> = ({ modules, onShowDiff }) => {
  const [selectedModuleId, setSelectedModuleId] = useState<string>("");

  // Get versions for the selected module
  const selectedModule = useMemo(
    () => modules.find((m) => m.id === selectedModuleId),
    [modules, selectedModuleId]
  );

  // Initialize with first module if available and none selected
  useState(() => {
    if (!selectedModuleId && modules.length > 0) {
      setSelectedModuleId(modules[0].id);
    }
  });

  return (
    <Box>
      <StyledSectionCard description="バージョン比較">
        <VStack spacing={4} align="stretch">
          {/* Module Selector */}
          <FormControl>
            <FormLabel fontSize="sm">モジュール</FormLabel>
            <Select
              size="sm"
              value={selectedModuleId}
              onChange={(e) => setSelectedModuleId(e.target.value)}
              placeholder="モジュールを選択してください"
            >
              {modules.map((module) => (
                <option key={module.id} value={module.id}>
                  {module.name} ({module.versions.length}件のバージョン)
                </option>
              ))}
            </Select>
          </FormControl>

          {/* Version Compare Panel */}
          {selectedModule && (
            <VersionComparePanel
              versions={selectedModule.versions.map((v) => ({
                ...v,
                sortKey: v.versionNumber,
              }))}
              getOptionLabel={(v) =>
                `v${v.versionNumber}（${userTagModuleStatusLabel(v.status)}）`
              }
              onShowDiff={onShowDiff}
            />
          )}
        </VStack>
      </StyledSectionCard>
    </Box>
  );
};
